import { Component, OnInit, ElementRef } from '@angular/core';

@Component ({
  selector: 'app-icon',
  styleUrls: ['./icon.component.scss'],
  templateUrl: './icon.component.html'
})
export class IconComponent implements OnInit {

  // Constants
  private iconColors = {
    PRIMARY: 'icon-primary',
    SECONDARY: 'icon-secondary',
    LIGHT: 'icon-light',
    DARK: 'icon-dark',
    GREY: 'icon-grey'
  }

  private iconSizes = {
    SMALL: 'icon-sm',
    LARGE: 'icon-lg'
  }

  // UI Variables
  public class: string;
  private color: string = '';
  private size: string = '';
  
  private icon: HTMLElement;

  constructor(private el: ElementRef) {
    this.icon = this.el.nativeElement as HTMLElement
  }

  ngOnInit(): void {
    this.setIconSize();
    this.setIconColor();
    this.setIconClass();
  }

  private setIconColor(): void {
    if (this.icon.hasAttribute('primary')) {
      this.color = this.iconColors.PRIMARY;
    }
    else if (this.icon.hasAttribute('secondary')) {
      this.color = this.iconColors.SECONDARY;
    }
    else if (this.icon.hasAttribute('dark')) {
      this.color = this.iconColors.DARK;
    }
    else if (this.icon.hasAttribute('light')) {
      this.color = this.iconColors.LIGHT;
    }
    else if (this.icon.hasAttribute('grey')) {
        this.color = this.iconColors.GREY;
    }
  }

  private setIconSize(): void {
    if (this.icon.hasAttribute('sm')) {
      this.size = this.iconSizes.SMALL;
    }
    else if (this.icon.hasAttribute('lg')) {
      this.size = this.iconSizes.LARGE;
    }
  }

  private setIconClass(): void {
    this.class = [this.size, this.color].join(' ');
  }

}